<template>
  <PublicPageTemplate>
    <template v-slot:content>
      <PublicPageHeader :title="computedTitle" :info="$t('authentication.recoveryCodeInfo')" class="mb-base" />
      <PublicPageContent>
        <template v-slot:content>
          <RecoveryCode :code="recoveryCode">
            <template v-slot:button="{ copyRecoveryCode }">
              <PublicPageSubmitButton :text="$t('mfa.copyCode')" @click="copyRecoveryCode" data-et="copy_code" data-ec="recovery_code" />
            </template>
          </RecoveryCode>
          <div class="leading-24 flex mt-sm">
            <VCheckbox
                id="user-has-stored-code-checkbox"
                class="ml-xs"
                type="checkbox"
                subtype="checkbox"
                v-model="userHasStoredCode"
                :checked="userHasStoredCode"
                data-ec="recovery_code"
                data-et="stored_recovery_code_confirmation_checkbox" />
            <span class="ml-base">{{ $t('authentication.iHaveStoredCode') }}</span>
          </div>
        </template>
      </PublicPageContent>
      <PublicPageSubmitButton :disabled="!userHasStoredCode" :text="$t('functional.continue')" @click="finishAuthentication" />
    </template>
  </PublicPageTemplate>

</template>

<script>
import { mapGetters } from 'vuex';
import PublicPageTemplate from '@/components/tailwind/publicPages/PublicPageTemplate.vue';
import PublicPageHeader from '@/components/tailwind/publicPages/PublicPageHeader.vue';
import PublicPageContent from '@/components/tailwind/publicPages/PublicPageContent.vue';
import PublicPageSubmitButton from '@/components/tailwind/publicPages/PublicPageSubmitButton.vue';
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';
import RecoveryCode from '@/components/tailwind/authentication/RecoveryCode.vue';

export default {
  name: 'MFARecoveryCode',
  components: {
    RecoveryCode,
    PublicPageHeader,
    PublicPageContent,
    PublicPageSubmitButton,
    PublicPageTemplate,
    VCheckbox,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.recoveryCode) {
        vm.$router.push('/');
      }
    });
  },
  props: {
    recoveryCode: {
      type: String,
      required: true,
    },
    mfaSetup: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      userHasStoredCode: false,
    };
  },
  computed: {
    ...mapGetters({
      userMfa: 'userMfa/userMfa',
    }),

    computedTitle() {
      return this.mfaSetup ? this.$t('authentication.recoveryCodeTitle') : this.$t('authentication.codeAcceptedNowSaveThisNewCode');
    },
  },
  methods: {
    finishAuthentication() {
      if (this.mfaSetup) {
        this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('authentication.setupSuccessMessage'), icon: 'check', type: 'success' }));
      }
      this.$router.push('/');
    },
  },
};
</script>
